import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import { IDeleteApkFirmwareValidationError, IServerError } from 'types';
import classNames from 'classnames';
import style from './ModalSentErrorWithInfo.module.scss';

interface IModalSentErrorWithInfo {
	onConsentEvent: () => void;
	isVisible: boolean;
	errorResponseData: IServerError<IDeleteApkFirmwareValidationError> | null;
}

const ModalSentErrorWithInfo: React.FC<IModalSentErrorWithInfo> = ({
	onConsentEvent,
	isVisible,
	errorResponseData,
}) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			<div className={style.wrapper}>
				<svg className={style.errorIcon}>
					<use xlinkHref={`${breadcrumbs}#error`} />
				</svg>
				<Text
					className={style.heading}
					translationNameSpace="modals"
					translationKey="firmwareAssignedToRestaurants"
					size="xxl"
					weight="bold"
					align="center"
				/>
				<div className={style.additionalInfoItems}>
					{errorResponseData?.Metadata?.restaurants.map((el, index, array) => (
						<Text
							className={style.additionalInfoItem}
							key={el.restaurantId}
							translationKey={`${el.name}${index !== array.length - 1 ? ',' : ''}`}
							theme="secondaryLight"
							size="l"
							weight="bold"
							withTooltip={true}
						/>
					))}
				</div>
				<div className={style.btnWrapper}>
					<Button className={style.okBtn} theme="primaryBlue" onClick={onConsentEvent} type="submit">
						<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ModalSentErrorWithInfo);
